<template>
  <div>
    <v-navigation-drawer
      :permanent="screenIsWideEnough"
      :temporary="!screenIsWideEnough"
      app
      class="grey lighten-2"
      clipped
      fixed
      floating
      right
      v-model="showFilterDrawer"
      width="675"
    >
      <v-toolbar v-if="!screenIsWideEnough" flat class="transparent">
        <v-toolbar-title>Advanced Search</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2" tile large icon v-on="on" @click="showDownload = true">
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
            <CustomerExportDialog :show.sync="showDownload" />
          </template>
          <span>Download customers as CSV</span>
        </v-tooltip>
        <v-btn icon @click.native.stop="showFilterDrawer = false"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card class="pa-3 transparent" flat>
        <v-card-title v-if="screenIsWideEnough" class="justify-space-between">
          <div class="title">Advanced Search</div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn class="ma-2" tile large icon v-on="on" @click="showDownload = true">
                <v-icon>fas fa-file-download</v-icon>
              </v-btn>
              <CustomerExportDialog :show.sync="showDownload" />
            </template>
            <span>Download customers as CSV</span>
          </v-tooltip>
        </v-card-title>

        <v-layout wrap>
          <v-flex class="mr-2">
            <v-layout column>
              <v-subheader>Dates</v-subheader>
              <v-menu
                ref="fromMenu"
                v-model="filterState.startDate.menu"
                transition="scale-transition"
                offset-y
                :close-on-content-click="false"
                :return-value.sync="startDate"
                class="ml-3"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Start date"
                    v-model="prettyStartDate"
                    prepend-inner-icon="event"
                    readonly
                    filled
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  scrollable
                  min="2016-05-01"
                  :max="new Date().toISOString().substr(0, 10)"
                  @change="$refs.fromMenu.save(startDate)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="filterState.startDate.menu = false">Cancel</v-btn>
                </v-date-picker>
              </v-menu>
              <v-menu
                ref="toMenu"
                v-model="filterState.endDate.menu"
                transition="scale-transition"
                offset-y
                :close-on-content-click="false"
                :return-value.sync="endDate"
                class="ml-3"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="End date"
                    v-model="prettyEndDate"
                    prepend-inner-icon="event"
                    readonly
                    filled
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  scrollable
                  :min="startDate"
                  :max="new Date().toISOString().substr(0, 10)"
                  @change="$refs.toMenu.save(endDate)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="filterState.endDate.menu = false">
                    Cancel
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-layout>
          </v-flex>

          <v-flex>
            <v-layout column>
              <v-subheader>
                Funding Amount
              </v-subheader>
              <v-text-field
                flat
                label="Funding minimum"
                v-model="fundingMinimum"
                filled
                hide-details
                prepend-inner-icon="mdi-currency-gbp"
                class="ml-3"
              ></v-text-field>
              <v-text-field
                flat
                label="Funding maximum"
                v-model="fundingMaximum"
                filled
                hide-details
                prepend-inner-icon="mdi-currency-gbp"
                class="ml-3"
                id="maxFunding"
              ></v-text-field>
            </v-layout>
          </v-flex>

          <v-flex xs12 v-if="UserHasRole('Platform') || UserHasRole('Call Centre')">
            <v-layout>
              <v-flex xs12>
                <v-select
                  :items="filterableJourneys"
                  item-text="name"
                  item-value="id"
                  v-model="selectedJourneyId"
                  placeholder="Active Journey"
                  clearable
                  dense
                  hide-details
                  class="ml-3"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  clearable
                  placeholder="Provider Enquiry Reference"
                  v-model="providerReference"
                  dense
                  hide-details
                  class="ml-3"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 sm6>
                <v-autocomplete
                  :items="Providers"
                  item-text="name"
                  item-value="id"
                  v-model="selectedProviderId"
                  clearable
                  placeholder="Provider"
                  dense
                  hide-details
                  class="ml-3"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete
                  :items="ProductsByProvider(selectedProviderId)"
                  item-text="name"
                  item-value="id"
                  v-model="selectedProductId"
                  placeholder="Product"
                  clearable
                  dense
                  hide-details
                  class="ml-3"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 sm6>
                <v-autocomplete
                  :items="referrers"
                  item-text="name"
                  return-object
                  v-model="referrerAccountId"
                  clearable
                  placeholder="Referrer"
                  dense
                  class="ml-3"
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  :items="referrerTypes"
                  item-text="name"
                  item-value="type"
                  v-model="referrerType"
                  placeholder="Referrer Type"
                  clearable
                  dense
                  class="ml-3"
                  hide-details
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-tabs class="ml-3 mt-3" background-color="grey lighten-3">
          <v-tabs-slider color="accent"></v-tabs-slider>
          <v-tab>Customer Filters</v-tab>
          <v-tab>Question Filters</v-tab>
          <v-tab-item>
            <filters></filters>
          </v-tab-item>
          <v-tab-item>
            <question-journey-tabs></question-journey-tabs>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-navigation-drawer>
    <v-app-bar app clipped-right dark flat class="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-layout>
        <v-flex xs9 lg6 xl11>
          <v-text-field
            name="search"
            class="search-field"
            v-model="search"
            prepend-inner-icon="search"
            clearable
            flat
            label="Search Customers"
            solo-inverted
            hide-details
            autocomplete="off"
          ></v-text-field>
          <span v-if="hasQueryError" class="floating-error">
            There is a problem with your query. Check for disallowed characters (e.g. /,(),*)
          </span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native.stop="showFilterDrawer = true" v-if="!screenIsWideEnough">
          <v-icon>filter_list</v-icon>
        </v-btn>
      </v-layout>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container fluid py-0 class="grey lighten-2">
        <v-layout class="fix active-filters" :class="{ 'is-filtered': CustomerPageHasFilters }" column pr-4>
          <active-filters></active-filters>
        </v-layout>
        <v-layout
          class="calc-height"
          :class="{ filtered: CustomerPageHasFilters }"
          column
          fill-height
          align-center
          justify-center
          v-if="CustomerTotal === 0"
        >
          <img
            src="https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/empty.png"
            alt=""
            height="191"
            width="600"
            style="opacity:0.4"
          />
          <p class="subtitle-1 mt-5 grey--text text--darken-2">
            No results found. Try changing the date range or removing some filters.
          </p>
        </v-layout>
        <v-layout
          class="calc-height"
          :class="{ CustomerPageHasFilters: 'filtered' }"
          column
          pr-4
          v-else-if="CustomerTotal > 0"
        >
          <v-layout mt-3 mb-2 style="z-index: 201">
            <v-flex xs6>
              <div class="title">{{ formattedTotal }} result<span v-if="CustomerTotal !== 1">s</span></div>
            </v-flex>
            <v-flex xs6>
              <div v-if="CustomerCurrentPage > 1" class="pr-3" style="text-align: right; z-index: 1001">
                <a @click="scrollToPosition(0)">Back to top</a>
              </div>
            </v-flex>
          </v-layout>
          <v-flex
            class="calc-central-height"
            pb-4
            :class="{ CustomerPageHasFilters: 'filtered' }"
            ref="scrollContainer"
            @scroll="getScrollPosition"
          >
            <customer-card
              v-for="customer in CustomerPage"
              :key="customer._source.id"
              :customer="customer._source"
              :selected-customer-id.sync="selectedCustomerId"
            ></customer-card>
            <mugen-scroll
              :handler="scrollPage"
              scroll-container="scrollContainer"
              :threshold="0.7"
              :should-handle="!loading"
              v-if="pagesAvailable"
            >
              <v-layout align-center justify-center>
                <v-progress-circular
                  size="25"
                  :width="3"
                  color="accent"
                  indeterminate
                  class="py-4"
                ></v-progress-circular>
              </v-layout>
            </mugen-scroll>
          </v-flex>
        </v-layout>
        <v-layout class="calc-height" column v-else pr-4>
          <v-flex class="calc-central-height">
            <v-layout fill-height align-center justify-center>
              <v-progress-circular size="70" :width="7" color="accent" indeterminate></v-progress-circular>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <v-fab-transition v-if="!UserHasRole('Property Broker')">
        <v-btn color="accent darken-1" dark fab fixed bottom right @click="showRegistration = true">
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-content>
    <customer-registration-dialog
      v-if="!UserHasRole('Property Broker')"
      :show.sync="showRegistration"
    ></customer-registration-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { DateTime } from 'luxon';

import { mapGetters, mapActions, mapState } from 'vuex';
import CustomerCard from './CustomerCard';
import CustomerRegistrationDialog from './CustomerRegistration/CustomerRegistrationDialog';
import CustomerExportDialog from './CustomerExportDialog';
import QuestionJourneyTabs from './Filters/QuestionJourneyTabs';
import Filters from './Filters/Filters';
import MugenScroll from 'vue-mugen-scroll';
import ActiveFilters from './Filters/ActiveFilters';

export default {
  components: {
    ActiveFilters,
    CustomerRegistrationDialog,
    CustomerExportDialog,
    CustomerCard,
    QuestionJourneyTabs,
    Filters,
    MugenScroll
  },
  name: 'Customers',
  data: () => ({
    // loading: false,
    providerTabs: null,
    tabs: null,
    selectedCustomerId: null,
    showFilterDrawer: false,
    showRegistration: false,
    showDownload: false,
    filterState: {
      toggles: [],
      owners: [],
      enquiryStatuses: [],
      startDate: {
        menu: false
      },
      endDate: {
        menu: false
      }
    },
    pagination: {
      sortBy: 'created_at',
      descending: true,
      rowsPerPage: 50,
      page: 1
    },
    referrerTypes: [
      { type: 'bank', name: 'Bank' },
      { type: 'broker', name: 'Broker' },
      { type: 'provider', name: 'Funder' },
      { type: 'partner', name: 'Partner' }
    ]
  }),
  computed: {
    ...mapState({
      hasQueryError: state => state.customer.hasQueryError
    }),
    ...mapGetters([
      'CustomerPage',
      'CustomerPageHasFilters',
      'CustomerTotal',
      'CustomerPageFilters',
      'CustomerPageScrollPosition',
      'CustomerFilteredAnswers',
      'CustomerCurrentPage',
      'CustomerLastPage',
      'CustomerSearch',
      'JourneyTypes',
      'ProductsByProvider',
      'Providers',
      'Questions',
      'RegistrationReferrerList',
      'UserHasRole',
      'UILeftDrawer'
    ]),
    loading() {
      return this.CustomerTotal === null;
    },
    page: {
      get() {
        return this.CustomerCurrentPage;
      },
      set(page) {
        this.setCustomerCurrentPage(page);
        this.getPage();
      }
    },
    search: {
      get() {
        return this.CustomerSearch;
      },
      set: _.debounce(function(value) {
        this.setCustomerSearch(value).then(() => this.getPage());
      }, 350)
    },
    startDate: {
      get() {
        return this.CustomerPageFilters.dates.from;
      },
      set(value) {
        this.setCustomerPageFromDate(value).then(() => {
          this.page = 1;
          this.getPage();
        });
      }
    },
    endDate: {
      get() {
        return this.CustomerPageFilters.dates.to;
      },
      set(value) {
        this.setCustomerPageToDate(value).then(() => {
          this.page = 1;
          this.getPage();
        });
      }
    },
    fundingMinimum: {
      get() {
        return this.currency(this.$store.state.customer.filters.funding.minimum);
      },
      set: _.debounce(function(amount) {
        amount = parseInt(amount.replace(/,/g, ''));
        if (amount < parseInt(this.fundingMaximum.replace(/,/g, ''))) {
          this.setCustomerPageFundingMinimum(amount).then(() => {
            this.page = 1;
            this.getPage();
          });
        }
      }, 100)
    },
    fundingMaximum: {
      get() {
        return this.currency(this.CustomerPageFilters.funding.maximum);
      },
      set: _.debounce(function(amount) {
        amount = parseInt(amount.replace(/,/g, ''));
        if (amount > 500000000) {
          document.getElementById('maxFunding').value = this.currency(500000000);
        } else if (amount > parseInt(this.fundingMinimum.toString().replace(/,/g, ''))) {
          this.setCustomerPageFundingMaximum(amount).then(() => {
            this.page = 1;
            this.getPage();
          });
        }
      }, 100)
    },
    prettyStartDate: function() {
      return _.isNull(this.startDate) ? null : DateTime.fromISO(this.startDate).toLocaleString();
    },
    prettyEndDate: function() {
      return _.isNull(this.endDate) ? null : DateTime.fromISO(this.endDate).toLocaleString();
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    pagesAvailable: function() {
      return this.CustomerCurrentPage <= this.CustomerLastPage;
    },
    selectedProductId: {
      get() {
        return this.CustomerPageFilters.productId;
      },
      set(productId = null) {
        this.setCustomerPageFilters({ productId });
        this.getPage();
      }
    },
    selectedProviderId: {
      get() {
        return this.CustomerPageFilters.providerId;
      },
      set(providerId = null) {
        this.setCustomerPageFilters({ providerId });
        this.getPage();
      }
    },
    selectedJourneyId: {
      get() {
        return this.CustomerPageFilters.journeyId;
      },
      set(journeyId = null) {
        this.setCustomerPageFilters({ journeyId });
        this.getPage();
      }
    },
    referrerAccountId: {
      get() {
        return this.CustomerPageFilters.referrer;
      },
      set(referrer = null) {
        this.setCustomerPageFilters({ referrer });
        this.getPage();
      }
    },
    referrerType: {
      get() {
        return this.CustomerPageFilters.referrerType;
      },
      set(referrerType = null) {
        this.setCustomerPageFilters({ referrerType });
        this.getPage();
      }
    },
    referrers() {
      return this.RegistrationReferrerList.slice(0).sort((a, b) => a.name.localeCompare(b.name));
    },
    formattedTotal() {
      // return this.CustomerTotal >= 1000 ? '1000+' : this.CustomerTotal;
      return this.CustomerTotal;
    },
    filterableJourneys() {
      return _.isNull(this.JourneyTypes[0].id) ? [] : this.JourneyTypes[1].journeys;
    },
    providerReference: {
      get() {
        return this.CustomerPageFilters.providerReference;
      },
      set(providerReference = null) {
        this.setCustomerPageFilters({ providerReference });
        this.getPage();
      }
    }
  },
  methods: {
    ...mapActions([
      'getAllProducts',
      'getCustomerPage',
      'getJourneyTypes',
      'getProviderList',
      'getQuestions',
      'getRegistrationReferrerList',
      'setCustomerCurrentPage',
      'setCustomerSearch',
      'setCustomerPageFilters',
      'setCustomerPageFromDate',
      'setCustomerPageToDate',
      'setCustomerPageFundingMinimum',
      'setCustomerPageFundingMaximum',
      'setCustomersScrollPosition',
      'updateUILeftDrawerState'
    ]),
    getPage: _.debounce(function() {
      this.getCustomerPage(false);
    }, 250),
    getScrollPosition: _.debounce(function() {
      this.setCustomersScrollPosition(this.$refs.scrollContainer.scrollTop);
    }, 250),
    scrollPage() {
      if (this.CustomerCurrentPage <= this.CustomerLastPage) {
        this.getCustomerPage(true);
      }
    },
    scrollToPosition(top, smooth = true) {
      const behavior = smooth ? 'smooth' : 'auto';
      if ('scrollBehavior' in document.documentElement.style) {
        this.$refs.scrollContainer.scrollTo({ top, behavior });
      } else {
        this.$refs.scrollContainer.scrollTo(0, top);
      }
    },
    selectCustomer(id) {
      if (id === this.selectedCustomerId) {
        this.clearSelectedCustomer();
      } else {
        this.selectedCustomerId = id;
      }
    },
    clearSelectedCustomer() {
      this.selectedCustomerId = null;
    },
    currency(value) {
      const intValue = typeof value === 'string' ? parseInt(value.replace(/[^\d.]/g, '')) : value;

      return intValue > 0
        ? intValue.toLocaleString({
            style: 'currency',
            currency: 'GBP',
            currencyDisplay: 'symbol',
            minimumSignificantDigits: 0,
            maximumSignificantDigits: 0
          })
        : value;
    }
  },
  mounted() {
    this.getProviderList();
    this.getAllProducts();
    this.getRegistrationReferrerList();
    if (_.isNull(this.JourneyTypes[0].id)) {
      this.getJourneyTypes();
    }
    if (_.isNull(this.Questions[0].id)) {
      this.getQuestions();
    }
    if (this.CustomerPage.length === 0) {
      this.getCustomerPage();
    } else {
      this.scrollToPosition(this.CustomerPageScrollPosition, false);
    }
  }
  // beforeRouteEnter(to, from, next) {
  //   next(vm => vm.getCustomerPage());
  // }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  &.filtered {
    height: calc(100vh - 180px);
    max-height: calc(100vh - 180px);
  }
}

.calc-central-height {
  height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  &.filtered {
    height: calc(100vh - 180px);
    max-height: calc(100vh - 180px);
  }
}

.selected {
  font-weight: 600;
}

.active-filters {
  height: 0;
  opacity: 0;
  transition: all 0.5s ease 0.2s;
  &.is-filtered {
    height: auto;
    opacity: 1;
  }
}

.floating-error {
  position: absolute;
  background-color: #f44336;
  padding: 5px 8px;
  margin-right: 50px;
  margin-top: 5px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  font-size: 1.2rem;
}

::v-deep .search-field input {
  caret-color: black;
}
</style>
